import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import DefaultLayout from './DefaultLayout';
import { Navigate } from 'react-router-dom';

function AbandonedSessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(localStorage.getItem("user"));
  const user = userData?.user || userData;

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get("https://luxurylifelimo.onrender.com/api/abandoned-sessions");
        setSessions(res.data);
      } catch (err) {
        console.error("Failed to fetch abandoned sessions:", err);
      } finally {
        setLoading(false);
      }
    }

    if (user?.role === "admin") {
      fetchData();
    }
  }, [user]);

  if (!user || user.role !== "admin") {
    return <Navigate to="/" />;
  }

  const columns = [
    {
      title: "User ID",
      dataIndex: "user",
    },
    {
        title: "Email",
        dataIndex: "email",
      },
      
    {
      title: "Car ID",
      dataIndex: "car",
    },
    {
      title: "From",
      dataIndex: "from",
    },
    {
      title: "To",
      dataIndex: "to",
    },
    {
      title: "Amount (USD)",
      dataIndex: "totalAmount",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: date => new Date(date).toLocaleString()
    }
  ];

  return (
    <DefaultLayout>
      <h2>Abandoned Sessions</h2>
      <Table
        columns={columns}
        dataSource={sessions}
        rowKey="_id"
        loading={loading}
      />
    </DefaultLayout>
  );
}

export default AbandonedSessions;
